import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  RECEIVED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  PENDING_2FA: "bg-amber-50 text-amber-800 border-amber-200",
  PAYMENT_PENDING: "bg-amber-50 text-amber-800 border-amber-200",
  PAYMENT_CONFIRMED: "bg-teal-50 text-teal-800 border-teal-200",
  SENT_TO_RTA: "bg-slate-50 text-slate-800 border-slate-200",
  ALLOTTED: "bg-emerald-50 text-emerald-800 border-emerald-300 font-semibold",
  REJECTED: "bg-orange-50 text-orange-800 border-orange-200",
  ACTIVE: "bg-emerald-50 text-emerald-800 border-emerald-200",
  PAUSED: "bg-amber-50 text-amber-800 border-amber-200",
  CANCELLED: "bg-slate-50 text-slate-600 border-slate-200",
  SHIFTED: "bg-slate-50 text-slate-600 border-slate-200",
  COMPLETED: "bg-teal-50 text-teal-800 border-teal-200",
  APPROVED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  CONFIRMED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  PENDING_REVIEW: "bg-amber-50 text-amber-800 border-amber-200",
  NOT_STARTED: "bg-slate-50 text-slate-600 border-slate-200",
  NOT_VERIFIED: "bg-amber-50 text-amber-800 border-amber-200",
  PENDING_BSE_AUTHENTICATION: "bg-amber-50 text-amber-800 border-amber-200",
  PENDING_BSE_RECONCILIATION: "bg-amber-50 text-amber-800 border-amber-200",
  SUCCESS: "bg-emerald-50 text-emerald-800 border-emerald-200",
  INITIATED: "bg-amber-50 text-amber-800 border-amber-200",
};

const STATUS_LABELS = {
  PENDING_2FA: "Awaiting 2FA",
  PAYMENT_PENDING: "Payment Pending",
  PAYMENT_CONFIRMED: "Payment Confirmed",
  SENT_TO_RTA: "Sent to RTA",
  PENDING_REVIEW: "Pending Review",
  NOT_STARTED: "Not Started",
  NOT_VERIFIED: "Not verified",
  PENDING_BSE_AUTHENTICATION: "Sent to BSE · authentication pending",
  PENDING_BSE_RECONCILIATION: "BSE confirmation pending",
};

export function StatusBadge({ status, className = "", testId }) {
  const style = STATUS_STYLES[status] || "bg-slate-50 text-slate-700 border-slate-200";
  const label = STATUS_LABELS[status] || (status ? status.replaceAll("_", " ") : "Unknown");
  return (
    <Badge variant="outline" className={`${style} ${className} rounded-full font-medium`} data-testid={testId}>
      {label}
    </Badge>
  );
}
